module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/success@2x_6445dc.png";